import React from "react";
import { all_routes } from "../router/all_routes";
import { useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

const ConfirmEmail = () => {
  const route = all_routes;
  const navigate = useNavigate();

  // Access state passed via `navigate`
  const location = useLocation();
  const { email } = location.state || {}; // Use fallback empty object to avoid errors
  const userEmail = email ? `"${email}"` : "";

  const handleLoginClick = () => {
    navigate(route.login);
  };

  return (
    <div className="main-wrapper authendication-pages forgot-password">
      {/* Page Content */}
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin  align-items-stretch">
            <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100 pb-0">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover img-fluid w-100 h-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12  col-lg-4 no-padding mt-2">
              <div className="dull-pg h-100">
                <div className="row no-margin vph-100 h-100 d-flex align-items-top justify-content-center">
                  <div className="col-sm-12 col-md-12 col-lg-12 mx-auto d-flex align-items-center justify-content-center">
                    <div className="shadow-card d-flex align-items-top justify-content-center h-100 w-100">
                      <div className="shadow-card-inner">
                        <header className="text-center">
                          <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </header>
                        <h2 className="text-center">Check your email</h2>
                        <p className="text-center">
                          We’ve sent you a password reset link to your email{" "}
                          {userEmail}. Please check mail and follow the
                          instructions.
                        </p>

                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            <button
                              onClick={handleLoginClick}
                              className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            >
                              Continue to login
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </div>
  );
};

export default ConfirmEmail;
